/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityNoDomainResponse
 */
export interface MonitEntityNoDomainResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNoDomainResponse
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNoDomainResponse
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNoDomainResponse
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNoDomainResponse
     */
    entity_domain?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityNoDomainResponse
     */
    domains?: Array<string>;
}

/**
 * Check if a given object implements the MonitEntityNoDomainResponse interface.
 */
export function instanceOfMonitEntityNoDomainResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityNoDomainResponseFromJSON(json: any): MonitEntityNoDomainResponse {
    return MonitEntityNoDomainResponseFromJSONTyped(json, false);
}

export function MonitEntityNoDomainResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityNoDomainResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'industry': !exists(json, 'industry') ? undefined : json['industry'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
    };
}

export function MonitEntityNoDomainResponseToJSON(value?: MonitEntityNoDomainResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_name': value.entity_name,
        'location': value.location,
        'industry': value.industry,
        'entity_domain': value.entity_domain,
        'domains': value.domains,
    };
}

